export const en = {
    cancel: 'Cancel'
};
